<!--短信链接弹窗-->
<template>
  <div class="short-popups" @click="noneBtn()">
    <div class="short-box-hug" v-if="oneState" @click.stop="stopPogetion()">
      <div class="popup-text-top">
        <span>插入短链接</span>
        <span style="float: right;margin-right: 30px;cursor: pointer;" @click="noneBtn()">X</span>
      </div>

      <!-- <div class="short-hug" style="margin-top: 20px;">
                <div class="short-left">常用地址：</div>
                <div class="short-right">
                    <div style="overflow: hidden;margin-top: 4px;margin-left: 25px;">
                        <div class="short-item" v-for="(item,index) in shortArray" :key="index"
                             @click="shortBtn(item.value)"
                             :style="{'color': shortUrl == item.value ? changeColor : '','border-bottom' : shortUrl == item.value ? '2px solid'+changeColor : '2px solid #fff'}">
                            {{item.name}}
                        </div>
                    </div>
                </div>
      </div>-->
      <!-- <div class="short-hug" style="margin-top: 10px;" v-if="shortUrl == 2">
                <div class="short-left">商品ID：</div>
                <div class="short-right">
                    <el-input v-model="shangId"
                              placeholder="请输入内容" 
                              style="width: 388px;" 
                              size="small"
                              maxlength="13"   
                              ></el-input>
                    <el-button type="primary" size="small" style="margin-left: 16px;width: 76px;" @click="addGoodsId()">
                        确定
                    </el-button>
                </div>
      </div>-->
      <!-- <div class="short-hug" style="margin-top: 10px;" v-if="shortUrl == 3">
                <div class="short-left">宝贝分类：</div>
                <div class="short-right">
                    <el-popover
                            placement="bottom"
                            width="385"
                            trigger="click">
                        <el-tree :data="sellerCats" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
                        <el-input slot="reference" placeholder="请选择宝贝分类" :readonly="true" size="small"
                                  style="display: inline-block; vertical-align: middle; width: 385px;"
                                  v-model="catsInput">click 激活
                        </el-input>
                    </el-popover>
                    <el-button type="primary" size="small"
                               style="display: inline-block; margin-left: 16px; width: 76px;"
                               @click="catsCheck()">确定
                    </el-button>
                </div>
      </div>-->
      <!-- <div class="short-hug" style="margin-top: 10px;" v-if="shortUrl == 4">
                <div class="short-left">优惠券地址：</div>
                <div class="short-right">
                    <div class="new-button" @click="Coupon"
                         :style="{'color': changeColor ,'border' :'1px solid'+changeColor}">选择优惠券
                    </div>
                </div>
      </div>-->

      <div class="short-hug" style="margin-top: 15px;" v-if="shortUrl != 4">
        <div class="short-left">URL地址：</div>
        <div class="short-right">
          <el-input
            type="textarea"
            :rows="7"
            placeholder="请输入内容"
            v-model="textarea"
            resize="none"
            style="width: 480px;"
          ></el-input>
          <p style="color:red;line-height:20px;">注：默认网址前、后都加空格，否则无法正常打开！另外直接从外部复制粘贴的网址也请务必前后加空格。</p>
        </div>
      </div>

      <div class="short-hug" style="margin-top: 15px;" v-if="shortUrl == 4">
        <div class="short-left" style="height: 50px;"></div>
        <div class="short-right">
          <el-input
            type="textarea"
            :rows="7"
            placeholder="请获取优惠券的链接"
            v-model="textarea"
            resize="none"
            style="width: 480px;"
            disabled
          ></el-input>
        </div>
      </div>
      <div class="short-hug" style="margin-top: 5px;">
        <div class="short-left">转化方式：</div>
        <div class="short-right">
          <div style="margin-top: 5px;">
            <el-radio-group v-model="radio">
              <!-- <el-radio label="1">智能短链(yei8.cn/7位)</el-radio> -->
              <el-radio label="3">淘短链接(c.tb.cn)</el-radio>
              <el-radio label="2">极短链接(yei8.cn/4位)</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="short-hug" style="margin-top: 5px;" v-if="isShowTip">
        <div class="short-left" style="height: 30px;"></div>
        <div class="short-right">
           <p style="color: red;">注意：使用淘短链接无法统计链接点击次数，建议使用智能短链或极短链接</p>
        </div>
      </div>
      <!-- <div class="short-hug" style="margin-top: 5px;">
                <div class="short-left" style="height: 30px;"></div>
                <div class="short-right">
                    <div class="short-bottom">
                        <div class="short-bgc" :style="{'background':changeColor}"></div>
                        <div class="short-bottom-hug" :style="{'color':changeColor}">
                            <div class="flex-short" style="margin-right: 20px;">
                                <span class="font_family icon-gouxuan"></span>
                                <span style="margin-left: 4px;">精确统计点击行为</span>
                            </div>
                            <div class="flex-short" style="margin-right: 30px;">
                                <span class="font_family icon-gouxuan"></span>
                                <span style="margin-left: 4px;">二次营销</span>
                            </div>
                            <div class="flex-short">
                                <span class="font_family icon-gouxuan"></span>
                                <span style="margin-left: 4px;">拉起淘宝APP打开</span>
                            </div>
                        </div>
                    </div>
                </div>
      </div>-->
      <div style="margin-top:20px;text-align:center;">
        <el-button type="primary" style="width:120px;" size="small" @click="sureBtn()">确定</el-button>
      </div>
      <!-- <div class="short-last">
                <el-button type="primary" size="small" @click="sureBtn()">确定</el-button>
      </div>-->
    </div>

    <div class="short-box-hug-two" v-if="!oneState" @click.stop="stopPogetion()">
      <div class="popup-text-top">
        <span>选择优惠券</span>
        <span style="float: right;margin-right: 30px;cursor: pointer;" @click="Coupon()">x</span>
      </div>
      <div class="btn-hug-right">
        <div style="margin:18px 30px 18px;">
          <el-button type="primary" plain size="small" style="width: 90px;height: 32px;font-size: 14px;padding: 0px;" @click="open">创建优惠券</el-button>
          <!-- <el-button type="primary" plain size="small" style="width: 90px;" @click="refresh">刷新</el-button> -->
          <span class="turnover"
                      style="margin-left:20px;cursor:pointer;float: right;line-height: 32px;"
                      @click="refresh" :style="{'color': changeColor }"><i :class="[rotate?'go':'aa']"
                      class="iconfont iconshuaxin"></i>&nbsp;刷新</span>
        </div>
      </div>
      <div class="short-hug" style="margin-top: 5px;">
        <div style="padding: 0 32px;">
          <el-table
            :data="couponList"
            style="width: 100%;border: 1px solid #E6E6E6;"
            :default-sort="{prop: 'date', order: 'descending'}"
            v-loading="loading"
          >
            <el-table-column prop="denominations" label="面额" width="100"></el-table-column>
            <el-table-column prop="condition" label="门槛"></el-table-column>
            <el-table-column label="使用时间" width="220">
              <template slot-scope="scope">
                <span style="display: block;">起：{{scope.row.creatTime}}</span>
                <span style="display: block;">止：{{scope.row.endTime}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="totalCount" label="发行量" sortable width="110"></el-table-column>
            <el-table-column prop="appliedCount" label="已领量" sortable width="110"></el-table-column>
            <el-table-column prop="personLimitCount" label="使用量" sortable width="110"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button @click="routerLinkBtn(scope.row.activityUrl)" type="text">获取链接</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: right; margin-top: 25px;">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="couponPaginationInfo.totalCount"
              :page-size="couponPaginationInfo.pageSize"
              @current-change="handleCouponCurrentChange"
              :current-page="couponPaginationInfo.tableCurrentPage"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCouponList, getSellercats, getShortUrl } from "@/api/public";
import { getSoftwareInfo } from "@/api/home";
import { mapState } from 'vuex'

export default {
  props: {
    isShowTip: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      rotate: false, //刷新按钮
      shortUrl: 1,
      // changeColor: "#2062E7",
      shortArray: [
        {
          name: "店铺首页",
          value: 1
        },
        {
          name: "商品链接",
          value: 2
        },
        {
          name: "宝贝分类",
          value: 3
        },
        {
          name: "优惠券",
          value: 4
        }
      ],
      defaultUrl: "", //默认店铺URL
      shopId: "", //商铺Id
      textarea: "", //URL展示框
      radio: "2",
      shangId: "",
      sellerCats: [],
      defaultProps: {
        children: "child",
        label: "speName001"
      },
      catsInput: "", //宝贝分类选择框内容
      catId: "", //选中分类的id
      oneState: true,
      couponList: [],
      /*
       * 优惠券列表分页数据
       * */
      couponPaginationInfo: {
        tableCurrentPage: 1,
        pageSize: 10,
        totalCount: 0
      },
      loading: false // 优惠劵列表loading加载
    };
  },
  watch: {},
  computed: {
    ...mapState({
      changeColor: 'globalBG'
    }),
  },
  mounted() {
    this.textarea = this.defaultUrl;
    /* 获取优惠券列表 */
    //this.getCouponList();
    /* 获取商家信息 */
    //this.getSoftwareInfo();
    /*
     * 获取店铺类目
     * */
    // getSellercats({}).then(res => {
      // console.log("%c 获取店铺类目", "color: green", res.data);

    //   this.sellerCats = res.data;
    // });
  },
  methods: {
    stopPogetion() {
      // 阻止冒泡
    },
    /*
     * 获取商家信息
     * */
    getSoftwareInfo() {
      getSoftwareInfo({}).then(res => {
        // console.log("%c 获取商家信息", "color: green", res);
        if (res.code === 200) {
          // let shopId = res.data.shopId;
          // this.textarea = this.defaultUrl + "shopId=" + shopId;
          // this.shopId = shopId;
        } else {
          this.$message.error("网络错误");
        }
      });
    },
    /*
     * 切换短链接类型
     * */
    shortBtn(type) {
      if (type == 1) {
        this.textarea = this.defaultUrl + "shopId=" + this.shopId;
      } else if (type != 4 && type != 1) {
        this.textarea = this.defaultUrl;
      } else if (type == 4) {
        this.textarea = "";
      }
      this.shortUrl = type;
    },
    /*
     * 关闭短链接窗口
     * */
    noneBtn() {
      this.$emit("transferName", {
        shortUrl: "",
        shortUrlId: ""
      });
    },
    /*
     * 拼接商品链接事件
     * */
    addGoodsId() {
      const that = this;
      let letter = that.shangId;
      let defaultUrl = that.defaultUrl;

      this.textarea = defaultUrl + "shop_id=" + letter;
    },
    /*
     * 拼接宝贝链接事件
     * */
    catsCheck() {
      const that = this;
      let catId = that.catId;
      let defaultUrl = that.defaultUrl;

      this.textarea = defaultUrl + "catId=" + catId;
    },
    /*
     * 确认按钮
     * */
    sureBtn() {
      let textarea = this.textarea;
      let radio = this.radio;
      getShortUrl({
        convertLinkType: radio,
        url: textarea
      }).then(res => {
        if (res.code === 200) {
          this.$message.success(res.message);

          this.$emit("transferName", {
            shortUrl: res.data.shortUrl,
            shortUrlId: res.data.shortUrlId,
            shortUrlType: radio
          });
        }
      });
    },
    /*
     * 宝贝分类选择按钮
     * */
    handleNodeClick(data) {
      // console.log(data);

      if (data.child.length === 0) {
        this.catsInput = data.speName001;
        this.catId = data.id;
      }
    },
    /*
     * 选择优惠券按钮
     * */
    Coupon() {
      this.oneState = !this.oneState;
    },
    /*
     * 获取优惠券列表
     * */
    getCouponList() {
      this.loading = true;
      getCouponList({
        pageNum: this.couponPaginationInfo.tableCurrentPage, //当前页
        pageSize: this.couponPaginationInfo.pageSize //每页大小,
      })
        .then(res => {
          this.loading = false;
          // console.log("%c 获取优惠券列表", "color: green", res);

          res.code === 200
            ? (this.couponList = res.data.dataList)
            : console.log("网络错误");

          this.couponPaginationInfo.totalCount = res.data.total;
        })
        .catch(res => {
          this.loading = false;
        });
    },
    /*
     * 切换系统分组分页事件
     * */
    handleCouponCurrentChange(val) {
      this.couponPaginationInfo.tableCurrentPage = val;
      this.getCouponList();
    },
    /*
     * 获取优惠券链接
     * */
    routerLinkBtn(value) {
      // console.log(value);

      this.Coupon();
      this.textarea = value;
    },
    /*
     * 创建优惠券事件
     * */
    open() {
      this.$alert(
        "由于淘宝优惠券限流，可将在淘宝后台创建的领取型优惠券，通过短信嵌入领取链接的方式发送给买家，引导买家领取优惠券。",
        "温馨提示",
        {
          confirmButtonText: "去后台创建优惠券",
          callback: action => {
            // this.$message.info(`action: ${action}`);
            if (action == "confirm") {
              window.open(
                "https://aliyx.taobao.com/coupon/create?couponType=0#/?_k=kddjv4"
              );
            }
          }
        }
      );

       console.log(
        "https://aliyx.dist.com/coupon/create?spm=a21y7.9633641.0.0.3ac86658QQ7bNr&couponType=0#/?_k=m9e8oz   "
      );
    },
    /*
     * 刷新获取优惠券列表
     * */
    refresh() {
      this.rotate = !this.rotate;
      this.getCouponList();
    }
  }
};
</script>
<!--短信链接弹窗-->
<style lang="scss" scoped>
@mixin translate($number, $number2) {
  -webkit-transform: translateX($number) translateY($number2);
  -moz-transform: translateX($number) translateY($number2);
  -ms-transform: translateX($number) translateY($number2);
  -o-transform: translateX($number) translateY($number2);
  transform: translateX($number) translateY($number2);
}

.short-popups {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2223;
  overflow-y: auto;
}

.short-box-hug {
  position: absolute;
  width: 631px;
  height: 446px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
  opacity: 1;
  border-radius: 4px;
  top: 50%;
  left: 50%;
  @include translate(-50%, -50%);
}

.short-box-hug-two {
  width: 1060px;
  height: 692px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  position: absolute;
  top: 50%;
  left: 50%;
  @include translate(-50%, -50%);
}

.popup-text-top {
  height: 52px;
  overflow: hidden;
  background: rgba(244, 245, 249, 1);

  span {
    font-size: 20px;
    font-family: "Microsoft YaHei";
    font-weight: 600;
    line-height: 52px;
    color: rgba(51, 51, 51, 1);
    margin-left: 30px;
  }
}

.short-hug {
  overflow: hidden;

  .new-button {
    width: 111px;
    height: 30px;
    background: rgba(255, 255, 255, 1);
    /*border:1px solid rgba(32,98,231,1);*/
    border-radius: 3px;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    /*color:rgba(32,98,231,1);*/
  }

  .short-left {
    width: 98px;
    float: left;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 30px;
    color: rgba(51, 51, 51, 1);
    text-align: right;
  }

  .short-right {
    width: 500px;
    float: left;
    overflow: hidden;
  }

  .short-item {
    float: left;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 600;
    line-height: 20px;
    color: rgba(153, 153, 153, 1);
    margin-right: 20px;
    cursor: pointer;
    /*border-bottom: 2px;*/
    /*color:rgba(32,98,231,1);*/
  }

  .short-bottom {
    height: 44px;
    /*width:478px;*/
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 44px;
    position: relative;
    width: 480px;

    .short-bottom-hug {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 44px;
    }

    /*color:rgba(32,98,231,1);*/
    .flex-short {
      float: left;
      /*width: 140px;*/
      margin-left: 22px;
      /*margin-right: 24px;*/
      /*margin-left: 44px;*/
    }

    .short-bgc {
      width: 100%;
      height: 100%;
      opacity: 0.1;
    }
  }
}

.short-last {
  position: absolute;
  bottom: 40px;
  left: 0;
  width: 100%;
  text-align: center;
}

.btn-hug-right {
  // text-align: right;
}
// 刷新按钮
.turnover {
  i {
    display: inline-block;
  }
  .aa {
    transition: all 2s;
    transform: rotate(0deg);
  }
  .go {
    transform: rotate(-360deg);
    transition: all 2s;
  }
}
</style>
<style>
.el-textarea__inner {
  border: 1px solid #dcdfe6 !important;
}
</style>
